
export const defaultPreferences = [
    {
        "personId": 2,
        "productId": 4,
        "person": "Bob",
        "product": "Basketball",
        "type": "positive"
    },
    {
        "personId": 2,
        "productId": 5,
        "person": "Bob",
        "product": "Golf",
        "type": "negative"
    },
    {
        "personId": 1,
        "productId": 6,
        "person": "Alice",
        "product": "Swimming",
        "type": "positive"
    },
    {
        "personId": 1,
        "productId": 1,
        "person": "Alice",
        "product": "Cycling",
        "type": "positive"
    },
    {
        "personId": 1,
        "productId": 4,
        "person": "Alice",
        "product": "Basketball",
        "type": "negative"
    },
    {
        "personId": 2,
        "productId": 3,
        "person": "Bob",
        "product": "Martial Arts",
        "type": "positive"
    },
    {
        "personId": 3,
        "productId": 5,
        "person": "Carol",
        "product": "Golf",
        "type": "positive"
    },
    {
        "personId": 3,
        "productId": 2,
        "person": "Carol",
        "product": "Skiing",
        "type": "positive"
    },
    {
        "personId": 3,
        "productId": 3,
        "person": "Carol",
        "product": "Martial Arts",
        "type": "negative"
    },
    {
        "personId": 4,
        "productId": 1,
        "person": "David",
        "product": "Cycling",
        "type": "positive"
    },
    {
        "personId": 4,
        "productId": 2,
        "person": "David",
        "product": "Skiing",
        "type": "positive"
    },
    {
        "personId": 4,
        "productId": 6,
        "person": "David",
        "product": "Swimming",
        "type": "negative"
    }
]